/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Visitor_Login_Required_LabelInputs */



/**
* | output |
* | --- |
* | "Require visitors to sign in" |
*
* @param {Artifact_Visitor_Login_Required_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_visitor_login_required_label = /** @type {((inputs?: Artifact_Visitor_Login_Required_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Visitor_Login_Required_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anmeldung für Besucher verlangen")
	return /** @type {LocalizedString} */ ("Require visitors to sign in")
});